import React, {useCallback, useEffect, useRef} from 'react';
import MainControlRoutes from './MainControlRoutes';
import {inject, observer} from 'mobx-react';
import {db} from '../../../firebase/Firebase';
import './main.css'

const options = {
    enableHighAccuracy: true,
    timeout: 10000,
    maximumAge: 0,
};

const useMountedState = () => {
    const mountedRef = useRef(false)
    const isMounted = useCallback(() => mountedRef.current, [])

    useEffect(() => {
        mountedRef.current = true

        return () => {
            mountedRef.current = false
        }
    }, [])

    return isMounted
}

function MainControl(props) {

    const {DataStore, ControlStore} = props;
    const {companyName, idCompany,  mainViewport} = DataStore

    const isMounted = useMountedState()

    const mainPath = db.collection(companyName).doc(idCompany);

    useEffect(() => {

        const GetCompanyData = async () => {
            await mainPath.onSnapshot(doc => {
                if (doc.exists) {
                    const contactNumbers = `Contactos : ${doc.data().celPhone}, ${doc.data().phone}`
                    const finished = doc.data().finished;
                    DataStore.getCompanyDataInfo(finished);
                    DataStore.getCompanyNumbers(contactNumbers)
                }
            });
        };

        const GetGeneralValues = async () => {
            await mainPath.collection('GeneralValues').doc(idCompany).get()
                .then((doc) => {
                    DataStore.getGeneralValues(doc.data().providerPercentage, doc.data().tripStartControl,
                        doc.data().maximumTimeReservation, doc.data().vehicleDisplay);
                })
        }

        if (isMounted()) {
            GetCompanyData().catch(() => {
            });
            GetGeneralValues().catch(() => {
            });
        }
        
    }, [DataStore, idCompany, isMounted, mainPath])
    
    useEffect(() => {
        const GetTypesVehiclesControl = async () => {
            await mainPath.collection('TypesVehicles').get()
                .then(sub => {
                    if (sub.empty) {
                        ControlStore.getTypesVehiclesStatus(false);
                    } else {
                        ControlStore.getTypesVehiclesStatus(true);
                    }
                });
        };

        const GetRoutesSchedulesControl = async () => {
            await mainPath.collection('Routes').get()
                .then(sub => {
                    if (sub.empty) {
                        ControlStore.getRoutesSchedulesControl(false);
                    } else {
                        ControlStore.getRoutesSchedulesControl(true);
                    }
                });
        };

        const GetDriversControl = async () => {
            await mainPath.collection('DriverManagement').get()
                .then(sub => {
                    if (sub.empty) {
                        ControlStore.getDriversFinished(false);
                    } else {
                        ControlStore.getDriversFinished(true);
                    }
                });
        };

        const GetRestrictZones = async () => {
            const data = [];
            await mainPath.collection('Restrict-Zones')
                .onSnapshot(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        const obj = {...doc.data(), id: doc.id};
                        data.push(obj);
                    });
                    DataStore.getRestrictZones(data);
                });
        };

        if (isMounted()) {
            GetTypesVehiclesControl().catch(() => {/**/
            });
            GetRoutesSchedulesControl().catch(() => {/**/
            });
            GetDriversControl().catch(() => {/**/
            });
            GetRestrictZones().catch(() => {/**/
            });
        }
        
        
    },[ControlStore, isMounted, mainPath])

    useEffect(() => {

        if (isMounted()) {
            function success(pos) {
                const crd = pos.coords;
                if (crd.latitude !== 0 && crd.longitude !== 0) {
                    DataStore.getViewPort({...mainViewport, latitude: crd.latitude, longitude: crd.longitude});
                }
            }

            function error(err) {
                // console.warn('ERROR(' + err.code + '): ' + err.message);
            }

            navigator.geolocation.getCurrentPosition(success, error, options);
        }
    }, [isMounted])

    return (
        <div style={{
            backgroundColor: '#fafafa',
            width: '100%',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <MainControlRoutes/>
        </div>
    )
}

export default inject('DataStore', 'ControlStore')(observer(MainControl));